import React from 'react';
import { useAuth } from 'src/hooks/useAuth';


const UserRow = ({ user,mcode }) => {

    const { user:userData } = useAuth();
    const getMcodeLabel = (code, section) => {
    const mcodeSection = mcode[section] || [];
    const matchingCode = mcodeSection.find(item => item.cd === code);
    return matchingCode ? matchingCode.code_value1 : 'N/A';
  };
  return (
    <tr>
      <td className="style_cl_name">
        <div>
          <div className="col-sm-9">
              <span id="user-icon-detail" className={`statusicon sta-icon${user?.icon_num}`}></span>
          </div>
        </div>
        <div>{user.name}</div>
          {(userData.auth_cd === "1" || userData.id === user.id) && (
          <div className="text-right">
            <a href={`/userEdit/${user.id}`} className="btn btn-default">
              <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
            </a>
          </div>
          )}
      </td>
      <td>{user.email}</td>
      <td style={{ textAlign: 'center', padding: '8px' }}>
        {getMcodeLabel(user.auth_cd, 'auth')}
      </td>
      <td style={{ textAlign: 'center' }}>
        {getMcodeLabel(user.working_hours_cd, 'workinghourscd')}
      </td>
      <td>{user.hire_date || 'N/A'}</td>
      <td></td>
    </tr>
  );
};

export default UserRow;
